export const MAIN_PATH = "/";
export const SIGNIN_PATH = "/signin";
export const SIGNUP_PATH = "/signup";
export const FORGOT_PASSWORD_PATH = "/restore-password";
export const RULES_PATH = "/rules.html";
export const ERROR_PAGE_404_PATH = "*";
